import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../../common/parent';
import {BllinkLogger} from '../../../common/utils/bllink_loggers';
import HalfPaid from '../../../images/half_checked.svg';
import FullPaid from '../../../images/full_paid.svg';
import ScheduledToPay from "../../../images/managers/scheduled_to_pay.png";
// import NonePaid from '../../../images/none_paid.svg';
import { constants } from "../../../common/constants/constants";
import MonthTableLogic from "./monthTableLogic";
import './tables.css';

class MonthsTable extends Parent {

    constructor(props) {
        super(props);

        this.renderIconExplanation.bind(this);
    }

    async componentDidMount() {
        await this.addHiddenBuildingTitle()
    }

    renderIcon(monthData, rowIndex){
        return MonthTableLogic.renderIcon(monthData, rowIndex)
    }

    renderOneTimeIcon(monthData){
        return MonthTableLogic.renderOneTimeIcon(monthData)
    }


    renderMonthText(monthData){
        return MonthTableLogic.renderMonthText(monthData)
    }

    renderApartmentLink(apartmentNumber){
        const buildingID = this.props.buildingID
        return <a href={`/${constants.pages.newApartmentReport}/${buildingID}/${apartmentNumber}`} >{apartmentNumber}</a>
    }


    renderApartment(apartmentNumber){
        return apartmentNumber
    }


    renderMonthLink(monthInt, monthName){
       const buildingID = this.props.buildingID
       const year = this.props.year
       return <a href={`/${constants.pages.monthlyCashFlowUrl}/${buildingID}/${monthInt}/${year}`} >{monthName}</a>
    }

    renderMonth(monthInt, monthName){
        return monthName
    }

    renderIconExplanation(){
          const {t} = this.props;

          return (
              <div className="lst-tbl-sec">
                  <ul className="lst-tbl-sec-id">
                      <li>
                          <div className="inline_layout-31">
                              <label className="label_container-8">
                                  <img alt="all paid" src={FullPaid}/>
                                  {t('reports.paid_explanation')}
                              </label>
                          </div>
                      </li>
                      <li>
                          <div className="inline_layout-31">
                              <label className="label_container-8">
                                  <img alt="half paid" src={HalfPaid}/>
                                  {t('reports.part_paid_explanation')}
                              </label>
                          </div>
                      </li>
                      <li>
                          <div className="inline_layout-31">
                              <label className="label_container-8">
                                  <img alt="none paid" src={ScheduledToPay}/>
                                  {t('reports.not_paid_explanation')}
                              </label>
                          </div>
                      </li>
                  </ul>
              </div>
          )
    }

    render() {
        BllinkLogger.info(`month tables is `, this.props);
        let rows = this.props.rows || [];
        let explanationSection;
        if (this.props.showExplanationSection){
            explanationSection = this.renderIconExplanation()
        }

        return (
            <section>
                <div className="cashflow-table table-fit mt-0" id="table_structure">
                    <div className="table-title">
                        <h4 className="js-table-title" tablename={this.props.tableType}>{this.props.title}</h4>
                        <span className={'hidden-except-print js-building-print-title'}/>
                    </div>
                    <table className={`table ${this.props.tableType} tableFixHead`}
                           data-excel-title={this.props.excelReportTitle} id="table">
                        <thead id="table-id">
                        <tr>
                            {this.props.headerNames.map((headerData, index)=>{
                                let item;
                                if (typeof headerData === 'string') {
                                    item = headerData
                                }else{
                                    item = this[headerData.functionName](headerData.data, headerData.label)
                                }

                                return <th className={'table-header'} key={index}>{item}</th>
                            })}
                        </tr>
                        </thead>
                        <tbody>
                        {rows.map((row, index) => {
                            // BllinkLogger.info(`table row is `, row)
                            return (
                                <tr key={index}>
                                    {this.props.fields.map((fieldData, index)=>{
                                        let item;
                                        if (typeof fieldData === 'string') {
                                            item = row[fieldData]
                                        }else{
                                            item = this[fieldData.functionName](row[fieldData.fieldName], this.props)
                                        }

                                        return <td key={index} className="js-payment-item">{item}</td>
                                    })}
                                </tr>
                            )
                        })}

                        </tbody>
                    </table>

                </div>
                {explanationSection}
            </section>
        )
    }
}


export default withTranslation()(MonthsTable)
